/** Identity artwork only. Product controls use the semantic app palette. */
export const brand = {
  spectrum: '#67B9E7',
  handoffArtwork: {
    cursorFill: '#edf5fb',
    cursorOutline: '#19212a',
    stroke: '19212a',
    routeStart: '#8bbbd5',
    routeMiddle: '#d7f0ff',
    routeEnd: '#a7cbb7',
    routeOutline: '#c9e8ff',
    sendPacket: '#b8e5ff',
    receivePacket: '#cce8bc',
  },
  discord: {
    main: '#5865F2',
    tint: 'rgba(88,101,242,0.18)',
    glow: 'rgba(88,101,242,0.1)',
    fill: '#5865F2',
    hover: '#6974F4',
  },
} as const;
